export const HightIMpactFeatures = () => {
    const hightImpact = [
        {
            heading: "CoreShare Talent Exchange",
            desc: "A unique recruiter-to-recruiter sharing network that lets you securely exchange candidates with attribution, credit tracking, and flexible models like fee-split or credits. It expands your reach without losing ownership or visibility of talent."
        },
        {
            heading: "AI-Powered Matching & Segmentation",
            desc: "Intelligent algorithms group candidates by skills, location, and availability, predicting fit beyond just keywords. It helps reduce bias and speeds up shortlisting by up to 40%."
        },
        {
            heading: "Branded Internal Job Boards",
            desc: "Launch beautiful, branded portals where employees, alumni, and past candidates can explore live roles tailored to them. It activates your internal network as a high-quality, zero-cost talent pool."
        },
        {
            heading: "Referral Engine with Automated Rewards",
            desc: "Enable fast, easy referrals from employees and contacts, with automated tracking and payout triggers. This removes admin work and drives more quality referrals through built-in engagement nudges."
        },
        {
            heading: "Seamless ATS Integration",
            desc: "Plug-and-play with AIAURA CORE ATS or your existing system—no migration, no retraining needed. It delivers instant value without disrupting your current hiring workflows."
        },
    ]
    return (
        <div className="max-w-7xl mx-auto relative">
            <p className="font-oxanium text-center font-medium px-6 text-white text-4xl mb-24">High-Impact <span className="text-[#04D1D6]">Features</span></p>
            <div className="relative z-10 flex flex-col gap-12">
                {hightImpact.map((item, index) => {
                    return (
                        <div className="flex items-start gap-10 px-6" key={index}>
                            <div className="">
                                <img src="/check-icon.svg" alt="" className="min-w-[35px] max-w-[35px]" />
                            </div>
                            <div className="text-white">
                                <p className="font-oxanium font-bold">{item.heading}</p>
                                <p className="font-lato text-xl font-light mt-4">{item.desc}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
            <img src="/circle1.png" alt="" className="h-[500px] absolute top-0 -left-[15%] z-0"/>
        </div>
    )
}
